import React from 'react';
import {
    ComponentMapping,
    Container,
} from "@adobe/aem-react-editable-components";
import './CarouselGalicia.scss'
import { CarouselV1IsEmptyFn, withAuthorPanelSwitch, withStandardBaseCssClass } from '@adobe/aem-core-components-react-spa';
import { impressionEvent } from '../../utils/AdobeDataLayerService';
import { scrollIntoComponent } from '../../utils/scrollIntoComponent';


const ComponentName = "Carousel Galicia"
class CarouselGalicia extends Container {
    constructor(props) {
        super(props);
        this.timerRef = React.createRef()
        this.containerRef = React.createRef()
        this.intervalRef = React.createRef()
        this.carouselRef = React.createRef()
        this.initialElement = React.createRef()
        this.lastElement = React.createRef()
        this.state = {
            componentMapping: this.props.componentMapping || ComponentMapping,
            activeIndex: 1,
            translateX: 0,
            onHover: false,
            touchPosition: null,
            impression: [],
            io: null,
            isVisible: false
        }
    }

    carruselItemActive = () => {
        if (!this.props?.isInEditor) {
            let url = window.location.hash.split("-")
            let itemId = url[1] ? url[1]?.trim() : "";
            if (itemId) {
                this.props.cqItemsOrder.map((item, index) => {
                        let itemFromProps = this.props.cqItems[item]
                        if (itemFromProps.id === itemId) {
                            const initialTranslateX = this.props.cqItemsOrder?.length > 1 ? this.containerRef?.current?.clientWidth * (index + 1) : 0;
                            this.setState({
                                activeIndex: index + 1,
                                translateX: initialTranslateX,
                                actualSize: this.context?.size
                            })
                    }
                })
            }
        }
    }

    componentDidMount() {
        const initialTranslateX = this.props.cqItemsOrder?.length > 1 ? this.containerRef?.current?.clientWidth * this.state.activeIndex : 0;
        this.setState({
            translateX: initialTranslateX,
            actualSize: this.context?.size
        })
        this.tagImpress()

        const { scrollIntoView } = scrollIntoComponent(this.props.id, this.props.isInEditor, true, this.carruselItemActive);
        this.timerRef.current = scrollIntoView();

        if(!this.props.isInEditor){

            this.setElementsNoFocusWithTab()

            if (this.props.autoplay) {
                this.io = new IntersectionObserver(this.callbackIntersect, {})
                if(this.carouselRef.current){
                    this.io.observe(this.carouselRef.current)
                }
                if (this.intervalRef.current) {
                    clearInterval(this.intervalRef.current)
                }
                this.intervalRef.current = setInterval(() => {
                    if(this.state.isVisible){
                        if (!this.state.onHover) {
                            this.handleAction("next")
                        }
                    }
                }, this.props.delay)
            }
            return () => {
                if (this.intervalRef.current) {
                    clearInterval(this.intervalRef.current)
                }
            }
        }
    }

    setElementsNoFocusWithTab = () => {
        let initialLinks = this.initialElement?.current?.querySelectorAll('a') || []
        initialLinks.forEach(link => {
            link.tabIndex = -1
        })
        let lastLinks = this.lastElement?.current?.querySelectorAll('a') || []
        lastLinks.forEach(link => {
            link.tabIndex = -1
        })
    }

    callbackIntersect = (entries) => {
        const entry = entries[0]
        this.setState({isVisible: entry.isIntersecting})
    }

    componentWillUnmount() {
        if (this.intervalRef.current) {
            clearInterval(this.intervalRef.current)
        }
        if(this.io){
            this.io.unobserve(this.carouselRef.current)
        }
        if (this.timerRef.current){
            clearTimeout(this.timerRef.current);
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {    
        if (this.props.activeIndexFromAuthorPanel !== undefined) {
            if (prevProps.activeIndexFromAuthorPanel !== this.props.activeIndexFromAuthorPanel) {
                this.setState({ activeIndex: this.props.activeIndexFromAuthorPanel + 1 });
            } else {
                const isItemDeleted = prevProps.cqItemsOrder.length !== this.props.cqItemsOrder.length;
                if (isItemDeleted) {
                    this.setState({ activeIndex: 1 });
                }
            }
        }
    }

    tagImpress() {
        let idItem = this.props.cqItems[this.props.cqItemsOrder[this.state.activeIndex-1]]?.id || null
        if(idItem){
            if(!this.state.impression.includes(idItem)){
                this.setState(prevState => ({
                    impression: [...prevState.impression, idItem] 
                }))
                this.props.cqItemsOrder.forEach((element, index) => {
                    if (index + 1 == this.state.activeIndex) {
                        let item = this.props.cqItems[element]
                        let type = item[':type']
                        let title = ''
                        let componentType = ''
                        let itemPosition = `${index + 1}`
                        if(type?.includes('primarymodulev2')){ 
                            title = item.primaryModuleV2?.title ? item.primaryModuleV2?.title : "";
                            componentType = 'Modulo primario v2';
                        }else if(type?.includes('primarymodule')){
                            title = item.primaryModule?.title ? item.primaryModule?.title : ""
                            componentType = 'Modulo primario'
                        }else if (type?.includes('secondarymodule')){
                            title = item.secondaryModule?.title ? item.secondaryModule?.title : ""
                            componentType = 'Modulo secundario'
                        }
                        else if (type?.includes('videomodule')){
                            title = item.videoModule?.title ? item.videoModule?.title : ""
                            componentType = 'Modulo de video'
                        }
                        impressionEvent(
                            [componentType, title],
                            "",
                            itemPosition
                        )
                    }
                });
            }
        }

    }

    renderContent() {
         const paddingMobile = this.props?.appliedCssClassNames?.includes("cmp-carousel__padding-mobile") ? "cmp-carousel__padding-mobile" : "";
        if (this.props.isInEditor) {
            return (
                <>
                    {this.childComponents.map((item, index) => {
                        const isVisible = this.state.activeIndex === index + 1;
                        const styles = { display: !isVisible ? "none" : "block" };
                        return (
                            <div
                                key={"carousel-content-" + index}
                                className={`cmp-carousel__item ${paddingMobile} ${isVisible ? "cmp-carousel__item--active" : ''} `}
                                data-cmp-index={index}
                                role="tabpanel"
                                data-cmp-hook-carousel="item"
                                aria-hidden={isVisible}
                                style={styles}
                            >
                                {item}
                            </div>
                        );
                    })}
                </>
            )

        } else {
            return (
                <div
                    className='cmp-carousel__content'
                    ref={this.containerRef}
                    style={{
                        transform: `translate3d(-${this.state.translateX}px, 0, 0)`
                    }}
                    onTransitionEnd={() => this.handleTransitionEnd()}
                    onTouchStart={(e) => this.handleTouchStart(e)}
                    onTouchMove={(e) => this.handleTouchMove(e)}
                    onMouseEnter={() => this.handleOnHover()}
                    onMouseLeave={() => this.handleOnHover()}
                    aria-label={this.props.accessibilityLabel}
                >   
                    {
                        this.props.cqItemsOrder?.length > 1
                            ?
                            <div className={`cmp-carousel__item ${paddingMobile} `} role="tabpanel" data-cmp-hook-carousel="item" key={"lastfirst0"} ref={this.initialElement} >
                                {this.childComponents[this.props.cqItemsOrder.length - 1]}
                            </div>
                            : null
                    }
                    {this.props.cqItemsOrder?.map((item, index) => {
                        return (
                            <div className={`cmp-carousel__item ${paddingMobile}`} role="tabpanel" data-cmp-hook-carousel="item" key={item} >
                                {this.childComponents[index]}
                            </div>
                        )
                    })
                    }
                    {
                        this.props.cqItemsOrder?.length > 1
                            ?
                            <div className={`cmp-carousel__item ${paddingMobile} `} role="tabpanel" data-cmp-hook-carousel="item" key={"lastfirst1"} ref={this.lastElement} >
                                {this.childComponents[0]}
                            </div>
                            : null
                    }
                </div>
            )
        }

    }

    handleKeyPress = (e, move) => {
        const keycode = e.keyCode || e.which;
        if (keycode === 13) {
            this.handleAction(move > 0 ? "next" : "prev");
        }
    }

    renderNavegation() {
        let isLarge = this.props.cqItemsOrder?.length > 1 // isLarge = more of one element
        return (
            <ol className="cmp-carousel__indicators" >
                {isLarge && (
                    <li 
                        className='cmp-carousel__nav cmp-carousel__nav--left'
                        tabIndex={0}
                        onClick={() => this.handleAction("prev")}
                        onKeyPress={(e) => this.handleKeyPress(e, -1)}
                    >
                        <i className='icon-left_arrow' ></i>
                    </li>
                )}
                {this.props.cqItemsOrder?.map((item, index) => {
                    let active = (index + 1) == this.state.activeIndex ? "cmp-carousel__indicator--active" : ""
                    return (
                        <li  className={`cmp-carousel__indicator ${active} `}
                            key={item + index} onClick={() => this.handleClickNav(index + 1)} >
                            {index}
                        </li>
                    )
                })}
                {isLarge && (
                    <li 
                        className='cmp-carousel__nav cmp-carousel__nav--rigth'
                        tabIndex={0}
                        onClick={() => this.handleAction("next")}
                        onKeyPress={(e) => this.handleKeyPress(e, 1)}
                    >
                        <i className='icon-right_arrow' ></i>
                    </li>
                )}
            </ol>
        )
    }

    handleClickNav = (moveTo) => {

        let aux = this.props.cqItemsOrder?.length > 1 ? this.containerRef.current.clientWidth * moveTo : 0;
        this.containerRef.current.style.transitionDuration = "700ms"
        this.setState({
            translateX: aux,
            activeIndex: moveTo
        })
        if (this.intervalRef.current) {
            clearInterval(this.intervalRef.current)
        }
    }

    handleAction = (mode) => {
        if(this.containerRef?.current){
            this.containerRef.current.style.transitionDuration = "700ms"
            if (mode === "prev") {
                if (this.state.activeIndex <= 1) {
                    this.setState({
                        translateX: 0,
                        activeIndex: this.props.cqItemsOrder.length
                    })
                } else {
                    let aux = this.containerRef.current.clientWidth * (this.state.activeIndex - 1)
                    this.setState(prev => ({
                        translateX: aux,
                        activeIndex: --prev.activeIndex
                    }))
                }
            } else if (mode === "next") {
                if (this.state.activeIndex >= this.props.cqItemsOrder?.length) {
                    let aux = this.props.cqItemsOrder?.length > 1 ? this.containerRef.current.clientWidth * (this.props.cqItemsOrder?.length + 1) : 0;
                    this.setState({
                        translateX: aux,
                        activeIndex: 1
                    })
                } else {
                    let aux = this.containerRef.current.clientWidth * (this.state.activeIndex + 1)
                    this.setState(prev => ({
                        translateX: aux,
                        activeIndex: ++prev.activeIndex
                    }))
                }
            }
        }
    }

    handleTransitionEnd = () => {
        if (this.state.activeIndex <= 1) {
            this.containerRef.current.style.transitionDuration = "0ms"
            let aux = this.props.cqItemsOrder?.length > 1 ? this.containerRef.current.clientWidth * this.state.activeIndex : 0;
            this.setState({
                translateX: aux
            })
        }

        if (this.state.activeIndex >= this.props.cqItemsOrder?.length) {
            this.containerRef.current.style.transitionDuration = "0ms"
            let aux = this.props.cqItemsOrder?.length > 1 ? this.containerRef.current.clientWidth * this.props.cqItemsOrder?.length : 0;
            this.setState({
                translateX: aux
            })
        }
        this.tagImpress()
    }

    handleTouchStart = (e) => {
        const touchDown = e.touches[0]?.clientX
        this.setState({
            touchPosition: touchDown
        })
    }

    handleTouchMove = (e) => {
        const touchDown = this.state.touchPosition
        if (touchDown === null) {
            return
        }
        const currentTouch = e.touches[0]?.clientX
        const diff = touchDown - currentTouch
        if (diff > 5) {
            this.handleAction("next")
        }
        if (diff < -5) {
            this.handleAction("prev")
        }
        this.setState({
            touchPosition: null
        })
    }

    handleOnHover = () => {
        if (!this.props?.autopauseDisabled) {
            this.setState({
                onHover: !this.state.onHover
            })
        }
    }

    render() {
        const isEmpty = CarouselV1IsEmptyFn(this.props)
        return (
            <div
                className={`cmp-carousel ${this.props.appliedCssClassNames ? this.props.appliedCssClassNames : ''}`}
                role="group"
                data-panelcontainer="carousel"
                aria-roledescription="carousel"
                ref={this.carouselRef}
                id={this.props.id}
            >
                {(isEmpty && this.props.isInEditor) && (
                    <div class="cq-Overlay--placeholder">
                        {ComponentName}
                    </div>
                )}
                {this.renderContent()}
                {this.renderNavegation()}
                {this.placeholderComponent}
            </div>
        );
    }
}

export default withStandardBaseCssClass(withAuthorPanelSwitch(CarouselGalicia), 'cmp-carousel');